// enroll.js
import { select } from '../shared/utils/dom';
import { delimiters } from '../shared/constants';
import { oneTimePaymentApi, userPreferenceApi, removeErrors } from './api';
import formMixin from '../shared/vue/mixins/form';
import multistepMixin from '../shared/vue/mixins/multistep';
import bankAccountMixin from '../shared/vue/mixins/bankAccount';

/**
 * Enrolling in auto pay
 */
export default function otherWaysToPay() {
  const el = select('[data-vue-app="other-ways-to-pay"]');

  if (el) {
    const app = new Vue({ // eslint-disable-line no-unused-vars
      el,
      delimiters,
      mixins: [bankAccountMixin, formMixin, multistepMixin],
      data: {
        accountNumber: '',
        amount: '',
        paymentusLink: '',
        success: true,
        errorGeneratingToken: false,
        loading: false,
        paymentusOnetimeMessageTypeId: '',
        showPaymentusOneTimeMessage: false,
      },
      mounted() {
        this.amount = (this.$el.dataset) ? this.$el.dataset.amount : '';
        this.accountNumber = (this.$el.dataset) ? this.$el.dataset.accountNumber : '';
        this.paymentusLink = (this.$el.dataset) ? this.$el.dataset.paymentusLink : '';
        this.paymentusOnetimeMessageTypeId = (this.$el.dataset) ? this.$el.dataset.paymentusOnetimeMessageTypeId : '';
        this.showPaymentusOneTimeMessage = (this.$el.dataset && this.$el.dataset.showPaymentusOneTimeMessage === 'True');
      },
      created() {
        Event.$on('A11yDialogConfirm:paymentus-one-time-message', () => {
          this.getPaymentusLinkAndSubmitForm();
        });
      },
      /**
       * Methods
       */
      methods: {
        getPaymentusLinkAndSubmitForm(e) {
          if (e) {
            e.preventDefault();
          }
          if (this.showPaymentusOneTimeMessage && this.paymentusOnetimeMessageTypeId && this.paymentusOnetimeMessageTypeId !== '') {
            this.showPaymentusOneTimeMessage = false;
            userPreferenceApi.storeUserPreference("QUICK_TIP", this.paymentusOnetimeMessageTypeId, "HIDE");
            Event.$emit('A11yDialogOpen', { dialogKey: 'paymentus-one-time-message' });
          } else {
            this.loading = true;

            this.errorGeneratingToken = false;
            const queryParams = {
              amount: this.amount,
            };

            oneTimePaymentApi.getPaymentToken(this.accountNumber, queryParams)
              .then((response) => {
                this.success = true;
                this.loading = false;
                this.$refs.paymentusForm.action = response;
                this.$refs.paymentusForm.submit();
              })
              .catch(() => {
                this.success = false;
                this.errorGeneratingToken = true;
                this.loading = false;
                removeErrors();
              })
          }
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/otherWaysToPay.js